export default __webpack_public_path__ + "static/sqlmap-0bd4d87b7930995e20e7721c936fe032.png";